<template>
    <div class="list">
        <NavBar></NavBar>
        <div class="background">
            <van-col span='24' style="text-align:center;font-weight:bold">{{obj.title}}</van-col>
            <van-col span='24' style="text-align:center;font-size:12px;color:gray;margin:5px 0">{{obj.createTime}}</van-col>
            <div v-html="obj.content"></div>
            <!-- <van-col span='24' style="font-weight:bold;font-size:14px">什么是维修资金?</van-col> -->
            <!-- <div class="ico_father">
                <van-col span='24' class="ico_first" style="font-size:12px;color:gray;margin-top:6px">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
                <van-icon class="ico-gift" name="gift-o" color="#1989fa" size="166px" />
            </div>
            <van-col span='24' style="font-weight:bold;font-size:14px;margin-top:10px">如何交存维修资金:</van-col>
            <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
            <van-col span='24' style="font-size:14px;margin-top:10px">第一步：登录并实名认证</van-col>
            <van-row style="margin-top:10px">
                <van-col span='6' style="font-size:52px;text-align:center;color: rgb(252, 178, 42);"><van-icon name="smile-o"/></van-col>
                <van-col span='18' style="font-size:12px;color:gray">说明文字说明明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
            </van-row>
            <van-col span='24' style="font-size:14px;margin-top:10px">第二步：查询房屋并核对交存金额</van-col>
            <van-row style="margin-top:10px">
                <van-col span='18' style="font-size:12px;color:gray">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
                <van-col span='6' style="font-size:52px;text-align:center;color: rgb(124, 194, 124);"><van-icon name="smile-o"/></van-col>
            </van-row>
            <van-col span='24' style="font-size:14px;margin-top:10px">第三步：确认金额并支付</van-col>
            <van-row style="margin-top:10px">
                <van-col span='6' style="font-size:52px;text-align:center;color:skyblue;"><van-icon name="smile-o"/></van-col>
                <van-col span='18' style="font-size:12px;color:gray">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
            </van-row>
            <van-col span='24' style="font-size:14px;margin-top:10px">第四步：支付成功并申请发票</van-col>
            <van-row style="margin-top:10px">
                <van-col span='18' style="font-size:12px;color:gray">文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明文字说明</van-col>
                <van-col span='6' style="font-size:52px;text-align:center;color: rgb(173, 67, 67);"><van-icon name="smile-o"/></van-col>
            </van-row> -->
            <!-- <van-col span='24' style="margin:35px 0 25px 0">
                <van-button type="danger"  size="normal" block :disabled='isShow' @click="ImmateLogin">立即登录并交存</van-button>
            </van-col> -->
            <van-col span='24' style="margin:35px 0 25px 0">
                <van-button type="danger"  size="normal" block v-if="!isShow" @click="ImmateLogin">立即登录并交存</van-button>
            </van-col>
            <!-- <van-col span='24' style="font-size:12px;color:gray;text-align:center;">威海南山维修资金宣</van-col> -->
             <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px',fontSize:'12px'}">
                威海南海新区住宅维修资金宣
            </van-divider>
            <!-- <van-col span='24' style="font-size:12px;color:gray;text-align:center;">联系电话:13255557777</van-col> -->
        </div>
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
    export default {
        data(){
            return{
                id:'',
                isRealName:'',
                isShow:false,
                obj:{}
            }
        },
        methods:{
            /**
             * 根据id查详情
             */
            getIdDetail(){
                let data={
                    id:this.id
                }
                this.$postQuery('/weChatNotice/getNoticeDetailById', data).then((response) => {
                    console.log(response)
                    //赋值的时候
                    this.obj = response.data
                })
            },
            /**
             * 立即登录
             */
            ImmateLogin(){
                this.$router.push({
                    path:'/FaceRecognition'
                })
            }
        },
        created(){
            this.id = this.$route.query.id
            this.getIdDetail()
            this.isRealName=VueCookie.get('isRealName')
            if(this.isRealName==0){
                this.isShow = false
            }else if(this.isRealName==1){
                this.isShow = true
            }
            // console.log(this.$route.query.id,'1111111111111')
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 46px;
    }
    .background{
        /* background-image:linear-gradient(to right, rgb(252, 225, 225) , rgb(245, 198, 112));; */
        /* width: 100%; */
        padding: 10px 15px;
        height: 100%;
       
    }
    .ico_father{
        position: relative;
    }
    .ico-gift{
        position: absolute;
        top: -21px;
        right: 16px;
        opacity: 0.13;
    }
    /* .ico_first{
        position: absolute;
        z-index: 999999999;
    } */
</style>